// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-dropdown-container {
  position: relative;
  width: 100%;
}

.custom-dropdown-selected {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: #ffffff;
  padding: 10px 14px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  transition: all 0.2s ease;
  -webkit-user-select: none;
          user-select: none;
}

.custom-dropdown-selected.active {
  border-color: #3bb3ae;
  box-shadow: 0 0 0 2px rgba(59, 179, 174, 0.15);
}

.custom-dropdown-selected.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.custom-dropdown-selected.error {
  border-color: #ff6b6b;
}

.custom-dropdown-options {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  border-radius: 8px;
  border: 1px solid rgba(72, 209, 204, 0.25);
  background-color: #0c1818;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.custom-dropdown-option {
  padding: 10px 16px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: all 0.15s ease;
}

.custom-dropdown-option:hover {
  background-color: rgba(72, 209, 204, 0.1);
  color: #ffffff;
}

.custom-dropdown-option.selected {
  background-color: rgba(72, 209, 204, 0.15);
  color: #48d1cc;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Shared/CustomDropdown.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;EACzB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".custom-dropdown-container {\n  position: relative;\n  width: 100%;\n}\n\n.custom-dropdown-selected {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 8px;\n  color: #ffffff;\n  padding: 10px 14px;\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  user-select: none;\n}\n\n.custom-dropdown-selected.active {\n  border-color: #3bb3ae;\n  box-shadow: 0 0 0 2px rgba(59, 179, 174, 0.15);\n}\n\n.custom-dropdown-selected.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.custom-dropdown-selected.error {\n  border-color: #ff6b6b;\n}\n\n.custom-dropdown-options {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  width: 100%;\n  max-height: 200px;\n  overflow-y: auto;\n  border-radius: 8px;\n  border: 1px solid rgba(72, 209, 204, 0.25);\n  background-color: #0c1818;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n}\n\n.custom-dropdown-option {\n  padding: 10px 16px;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.7);\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.custom-dropdown-option:hover {\n  background-color: rgba(72, 209, 204, 0.1);\n  color: #ffffff;\n}\n\n.custom-dropdown-option.selected {\n  background-color: rgba(72, 209, 204, 0.15);\n  color: #48d1cc;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
